/* Glimmr Duo Subscription — shared client JS
   Includes: autoScroll (marquee + ingredients ticker), makeDraggable
   (drag-to-scroll for ticker), timeline scroll-fill, types carousel,
   product gallery / tabs, review filters, tweaks panel, mobile prod
   carousel. Loaded once by sections/duo-page-init.liquid. */
(function(){
  if (window.__GlimmrDuoLoaded) return;
  window.__GlimmrDuoLoaded = true;

  function init(){
/* ═════ Tweak default storage ═════ */
    const TWEAK_DEFAULTS = /*EDITMODE-BEGIN*/{
      "bg": "rgb(220,225,236)",
      "accent": "rgb(238,94,62)"
    }/*EDITMODE-END*/;

    /* Product thumbnail gallery */
    document.querySelectorAll('.prod-thumbs button').forEach(btn => {
      btn.addEventListener('click', () => {
        document.querySelectorAll('.prod-thumbs button').forEach(b => b.setAttribute('aria-selected', 'false'));
        btn.setAttribute('aria-selected', 'true');
        document.getElementById('gal-img').src = btn.dataset.img;
      });
    });

    /* Product info tabs */
    document.querySelectorAll('.prod-tabs button').forEach(btn => {
      btn.addEventListener('click', () => {
        const tab = btn.dataset.tab;
        document.querySelectorAll('.prod-tabs button').forEach(b => b.setAttribute('aria-selected', b === btn ? 'true' : 'false'));
        document.querySelectorAll('.prod-side [data-panel]').forEach(p => {
          p.hidden = (p.dataset.panel !== tab);
        });
      });
    });

    /* Hair types carousel */
    const track = document.getElementById('types-track');
    const viewport = track.parentElement; /* .types-viewport */
    const STEP = 434 + 24; /* card width + gap */
    let idx = 0;
    const advance = (d) => {
      /* The natural maximum scroll distance of the track inside the viewport.
         Clamp the requested shift to this so the last card stops flush
         against the right edge instead of revealing empty space. */
      const maxScroll = Math.max(0, track.scrollWidth - viewport.clientWidth);
      const maxIdx = Math.ceil(maxScroll / STEP);
      idx = Math.max(0, Math.min(maxIdx, idx + d));
      const shift = Math.min(idx * STEP, maxScroll);
      track.style.transform = `translateX(-${shift}px)`;
    };
    document.getElementById('types-prev').addEventListener('click', () => advance(-1));
    document.getElementById('types-next').addEventListener('click', () => advance(1));

    /* ─── Auto-scrolling tracks (marquee + ingredients ticker) ───
       Two things this implementation has to get right that a CSS
       @keyframes loop doesn't:

       (a) NO WHITESPACE before the wrap. If the track is only 1 copy
           of the content + 1 clone, the rightmost edge of the track
           reaches the rightmost edge of the viewport while we still
           have ~1 cycle of scroll left to do — and the user sees blank
           space behind the last card. We fix this by auto-cloning the
           original content enough times so the track is always at
           least 2× the viewport width.

       (b) NO FLICKER at the wrap. We use a modulo-style reset on `pos`
           so any sub-pixel drift gets absorbed cleanly. Because every
           clone is identical to the original, pos = 0 and pos = -cycle
           are visually indistinguishable; the reset is invisible. */
    function autoScroll(track, opts) {
      if (!track) return null;
      opts = opts || {};
      const desktopOnly = !!opts.desktopOnly;
      const reverse = !!opts.reverse;
      const desktopMq = window.matchMedia('(min-width: 1101px)');
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const host = track.parentElement;

      /* Snapshot the original (non-clone) children once. Later resizes
         tear down all clones and re-add fresh ones to fit the new width. */
      const initial = Array.from(track.children);
      const firstCloneIdx = initial.findIndex(el => el.getAttribute('aria-hidden') === 'true');
      const origCount = firstCloneIdx >= 0 ? firstCloneIdx : initial.length;
      const origItems = initial.slice(0, origCount);

      function isActiveViewport() {
        return !desktopOnly || desktopMq.matches;
      }

      function currentSpeed() {
        const desktop = desktopMq.matches;
        return (desktop ? opts.desktopSpeed : opts.mobileSpeed) || opts.speed || 50;
      }

      function ensureFilled() {
        /* Strip every existing clone (anything past the originals). */
        while (track.children.length > origCount) {
          track.removeChild(track.lastChild);
        }
        /* Append clone-sets until the track is comfortably wider than
           viewport + 1 cycle. The 100px padding is breathing room so
           the wrap never coincides with the right edge of the viewport. */
        let copies = 0;
        while (copies < 8) {
          origItems.forEach(function (item) {
            const clone = item.cloneNode(true);
            clone.setAttribute('aria-hidden', 'true');
            track.appendChild(clone);
          });
          copies++;
          if (track.scrollWidth >= host.clientWidth * 2 + 100) break;
        }
      }

      let pos = 0, last = performance.now(), paused = false, cycle = 0;

      function measure() {
        const all = track.children;
        /* Cycle = distance from the first original to the first clone.
           Both are visually identical, so wrapping by `cycle` is a no-op
           visually — that's what makes the loop seamless. */
        if (all.length > origCount) {
          cycle = all[origCount].offsetLeft - all[0].offsetLeft;
        } else {
          cycle = track.scrollWidth;
        }
      }

      function setup() {
        if (!isActiveViewport()) {
          while (track.children.length > origCount) {
            track.removeChild(track.lastChild);
          }
          pos = 0;
          cycle = 0;
          paused = true;
          track.style.transform = '';
          return;
        }
        paused = false;
        ensureFilled();
        measure();
        /* Reverse (rightward) starts at -cycle and eases toward 0 so the
           appended clones stay in view for a seamless loop. */
        pos = reverse && cycle > 0 ? -cycle : 0;
        track.style.transform = 'translate3d(' + pos + 'px,0,0)';
      }

      setup();
      /* Images and webfonts settle after first paint — re-measure once. */
      window.addEventListener('load', function () {
        if (isActiveViewport()) measure();
      }, { once: true });

      function tick(now) {
        if (isActiveViewport() && !paused && cycle > 0 && !reduce) {
          const dt = Math.min(0.05, (now - last) / 1000);
          if (reverse) {
            pos += currentSpeed() * dt;
            if (pos >= 0) pos -= cycle;
          } else {
            pos -= currentSpeed() * dt;
            /* Modulo-style wrap: keeps pos in (-cycle, 0]. Any sub-pixel
               drift is absorbed by the wrap rather than accumulated. */
            if (pos <= -cycle) pos += cycle;
          }
          track.style.transform = 'translate3d(' + pos + 'px,0,0)';
        }
        last = now;
        requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);

      /* Pause on hover (desktop only — touch devices don't fire these). */
      host.addEventListener('mouseenter', function () {
        if (isActiveViewport()) paused = true;
      });
      host.addEventListener('mouseleave', function () {
        if (!isActiveViewport()) return;
        last = performance.now();
        paused = false;
      });

      let rt;
      window.addEventListener('resize', function () {
        clearTimeout(rt);
        rt = setTimeout(setup, 200);
      });

      if (typeof desktopMq.addEventListener === 'function') {
        desktopMq.addEventListener('change', setup);
      } else if (typeof desktopMq.addListener === 'function') {
        desktopMq.addListener(setup);
      }

      /* Public control surface — used by makeDraggable() below to take
         over the position while the user drags, then hand it back.
         refresh() re-clones/measures after a previously-hidden panel
         becomes visible (ingredient tabs). */
      return {
        track: track,
        host: host,
        getPos: function () { return pos; },
        setPos: function (p) {
          if (!isActiveViewport()) return;
          pos = p;
          track.style.transform = 'translate3d(' + p + 'px,0,0)';
        },
        pause: function (b) {
          paused = !!b;
          if (!paused) last = performance.now();
        },
        getCycle: function () { return cycle; },
        isActiveViewport: isActiveViewport,
        refresh: setup
      };
    }

    /* ─── Drag-to-scroll for an autoScroll'd track ───
       While the pointer is down, the user drives the track position
       directly. The autoScroll loop is paused; on release we hand the
       position back and the loop resumes from wherever it landed. */
    function makeDraggable(ctl) {
      if (!ctl) return;
      const host = ctl.host;
      let dragging = false;
      let startX = 0;
      let startPos = 0;
      let pointerId = null;

      function down(e) {
        if (dragging) return;
        if (ctl.isActiveViewport && !ctl.isActiveViewport()) return;
        dragging = true;
        startX = e.clientX;
        startPos = ctl.getPos();
        ctl.pause(true);
        host.classList.add('is-dragging');
        if (e.pointerId != null) {
          pointerId = e.pointerId;
          if (host.setPointerCapture) {
            try { host.setPointerCapture(pointerId); } catch (_) {}
          }
        }
      }

      function move(e) {
        if (!dragging) return;
        const delta = e.clientX - startX;
        let next = startPos + delta;
        const cycle = ctl.getCycle();
        if (cycle > 0) {
          /* Wrap into (-cycle, 0] so dragging can spin freely in either
             direction without the track running out of clones. */
          next = next % cycle;
          if (next > 0) next -= cycle;
        }
        ctl.setPos(next);
        if (e.cancelable) e.preventDefault();
      }

      function up() {
        if (!dragging) return;
        dragging = false;
        if (pointerId != null && host.releasePointerCapture) {
          try { host.releasePointerCapture(pointerId); } catch (_) {}
        }
        pointerId = null;
        ctl.pause(false);
        host.classList.remove('is-dragging');
      }

      if (window.PointerEvent) {
        host.addEventListener('pointerdown', down);
        host.addEventListener('pointermove', move);
        host.addEventListener('pointerup', up);
        host.addEventListener('pointercancel', up);
        host.addEventListener('pointerleave', up);
      } else {
        host.addEventListener('mousedown', down);
        document.addEventListener('mousemove', move);
        document.addEventListener('mouseup', up);
        host.addEventListener('touchstart', function (e) {
          if (e.touches && e.touches[0]) down({ clientX: e.touches[0].clientX });
        }, { passive: true });
        document.addEventListener('touchmove', function (e) {
          if (e.touches && e.touches[0]) move({ clientX: e.touches[0].clientX, cancelable: e.cancelable, preventDefault: function () { e.preventDefault(); } });
        }, { passive: false });
        document.addEventListener('touchend', up);
      }
    }

    autoScroll(document.querySelector('.marquee-track'), { desktopSpeed: 90, mobileSpeed: 50 });
    const ingredientTickerControls = new Map();
    document.querySelectorAll('.ingredients-ticker .ticker-track').forEach(function (track) {
      const tickerCtl = autoScroll(track, {
        desktopSpeed: 70,
        mobileSpeed: 40,
        desktopOnly: true,
        reverse: track.getAttribute('data-ticker-direction') === 'right'
      });
      makeDraggable(tickerCtl);
      if (tickerCtl) ingredientTickerControls.set(track, tickerCtl);
    });

    /* Ingredient product tabs: Shampoo | Conditioner.
       Swaps which product ticker/list is visible (desktop + mobile).
       Refresh the newly shown ticker so clones/cycle measure correctly
       after display:none → block. */
    document.querySelectorAll('.ingredients-ticker .ing-product-tab').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const tab = btn.dataset.ingTab;
        const root = btn.closest('.ingredients-ticker');
        if (!root || !tab) return;
        root.querySelectorAll('.ing-product-tab').forEach(function (b) {
          b.setAttribute('aria-selected', b === btn ? 'true' : 'false');
        });
        root.querySelectorAll('.ing-product').forEach(function (panel) {
          const active = panel.dataset.ingPanel === tab;
          panel.classList.toggle('is-active', active);
          if (!active) return;
          const track = panel.querySelector('.ticker-track');
          const ctl = track && ingredientTickerControls.get(track);
          if (ctl && typeof ctl.refresh === 'function') {
            requestAnimationFrame(function () { ctl.refresh(); });
          }
        });
      });
    });

    /* ─── Timeline scroll-fill animation ───
       The .tl-list has a gray base line (.tl-track-line) and a black
       overlay (.tl-track-fill). The overlay is full height in CSS and
       we drive its visible amount by scaling on the Y axis. Two tricks
       for smoothness:
         1. Hardware-accelerated transform: scaleY (sub-pixel precision,
            no per-frame layout) instead of animating `height`.
         2. A continuous RAF loop that lerps the actual progress toward
            the scroll-derived target — small scroll deltas get smoothed
            out into a fluid, "easing" motion rather than 1:1 snapping. */
    (function timelineFill() {
      const list = document.getElementById('tl-list');
      if (!list) return;
      const fill = list.querySelector('.tl-track-fill');
      if (!fill) return;

      let target = 0;     /* progress derived from scroll, 0..1 */
      let actual = 0;     /* lerped value applied to transform, 0..1 */
      const SMOOTHING = 0.14;  /* fraction of remaining gap closed per frame */

      function readTarget() {
        const rect = list.getBoundingClientRect();
        const trackHeight = rect.height;
        if (trackHeight <= 0) {
          target = 0;
          return;
        }
        const viewportCenter = window.innerHeight / 2;
        const scrolledPast = viewportCenter - rect.top;
        target = Math.max(0, Math.min(1, scrolledPast / trackHeight));
      }

      function tick() {
        readTarget();
        /* Snap to target if we're effectively there to avoid endless
           tiny updates costing a frame each. */
        const diff = target - actual;
        if (Math.abs(diff) < 0.0008) {
          actual = target;
        } else {
          actual += diff * SMOOTHING;
        }
        fill.style.transform = 'scaleY(' + actual + ')';
        requestAnimationFrame(tick);
      }

      readTarget();
      actual = target; /* avoid an initial sweep on page-load */
      requestAnimationFrame(tick);
    })();

    /* Review filters (visual only) */
    document.querySelectorAll('.review-filters button').forEach(b => {
      b.addEventListener('click', () => {
        document.querySelectorAll('.review-filters button').forEach(x => x.classList.remove('active'));
        b.classList.add('active');
      });
    });

    /* Tweaks wiring */
    const panel = document.getElementById('tweaksPanel');
    function applyTweaks(t) {
      if (t.bg) document.documentElement.style.setProperty('--bg', t.bg);
      if (t.accent) document.documentElement.style.setProperty('--coral', t.accent);
    }
    applyTweaks(TWEAK_DEFAULTS);

    window.addEventListener('message', (e) => {
      if (!e.data || !e.data.type) return;
      if (e.data.type === '__activate_edit_mode') panel.classList.add('on');
      if (e.data.type === '__deactivate_edit_mode') panel.classList.remove('on');
    });
    window.parent.postMessage({ type: '__edit_mode_available' }, '*');

    panel.querySelectorAll('.row').forEach(row => {
      row.addEventListener('click', (e) => {
        const sw = e.target.closest('.swatch'); if (!sw) return;
        row.querySelectorAll('.swatch').forEach(x => x.classList.remove('active'));
        sw.classList.add('active');
        const kind = row.dataset.kind, val = sw.dataset.val;
        applyTweaks({ [kind]: val });
        window.parent.postMessage({ type: '__edit_mode_set_keys', edits: { [kind]: val } }, '*');
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
